module.exports = __webpack_public_path__ + "img/34.7821a82c.webp";